import { useAssetSchemaFF } from '@Components/hooks/useAssetSchemaFF';
import { AssetSchema, SystemType } from '@innovyze/lib_asset_schema';
import {
	assetSchemaSelectorBySystemType,
	getAllAssetsSchemaAction,
	getAssetSchemaAction,
	systemSchemaSelector,
} from '@innovyze/lib_asset_schema_store';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export function useEnabledSystemTypes(): {
	enabledSystemTypes: SystemType[];
} {
	const dispatch = useDispatch();
	const { isValidSystemType } = useAssetSchemaFF();

	useEffect(() => {
		dispatch(getAllAssetsSchemaAction());
	}, [dispatch]);

	const allSystemTypes: SystemType[] = useSelector(state => {
		return Object.values(systemSchemaSelector(state));
	});

	const enabledSystemTypes = allSystemTypes.filter(systemType => {
		return isValidSystemType(systemType);
	});

	return { enabledSystemTypes };
}

export function useEnabledAssetTypes(systemType?: SystemType): {
	enabledAssetTypes: AssetSchema[];
} {
	const dispatch = useDispatch();
	const { isValidAssetType } = useAssetSchemaFF();

	useEffect(() => {
		if (systemType) {
			dispatch(getAssetSchemaAction(systemType.id));
		}
	}, [dispatch, systemType]);

	const allAssetTypes: AssetSchema[] | undefined = useSelector(state => {
		if (systemType !== undefined) {
			return assetSchemaSelectorBySystemType(state, systemType.id);
		}
	});

	if (!systemType) {
		return { enabledAssetTypes: [] };
	}

	if (!allAssetTypes) {
		return { enabledAssetTypes: [] };
	}

	const enabledAssetTypes = allAssetTypes.filter(assetType => {
		return isValidAssetType(assetType);
	});

	return {
		enabledAssetTypes,
	};
}

export function useEnabledInspectionStandards(assetType?: AssetSchema): {
	enabledInspectionStandards: string[];
} {
	const enabledInspectionStandards = assetType?.getInspectionTypes() ?? [];

	return { enabledInspectionStandards };
}
